module.exports = __webpack_public_path__ + "img/9.fcf3d52e.png";